import { cn } from '@wwe-portal/ui/lib/lib';

import { Reward } from './reward';

export function Footer({
  actionBtn,
  rewards,
  isSingleContent,
}: Readonly<{
  actionBtn: React.ReactNode;
  rewards: string[];
  isSingleContent: boolean;
}>) {
  return (
    <div>
      {Boolean(rewards.length) && (
        <Reward
          className={cn('xs:w-[382px] w-[334px] md:w-[430px]', {
            'xs:w-[334px] -left-[10px] sm:-left-[12px]': isSingleContent,
          })}
          rewards={rewards}
        />
      )}
      <div className="mx-6 pb-6">{actionBtn}</div>
    </div>
  );
}
